module.exports = __webpack_public_path__ + "static/media/day13.workshop.1225bb8c.md";